module.exports = "<h2 class=\"hidden\">{{t('portDetails.aggregatedPortDetails')|e}}</h2>\n<div class=\"rg-aggregated-ports-list\"></div>\n";
